// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"02be7fd7","796":"c4f479b9","811":"760fbfa2","961":"4f0805d6"}[chunkId] + ".chunk.js";
};